export default __webpack_public_path__ + "static/media/AnyConv.com__Inter-Bold.e247b5c5.ttf";